import React, { useMemo } from 'react'
import { handleDeepLink } from '@/service/utils'
import './index.less'

const WalkIn = ({ guide }) => {
  const { intro_title, intro_desc, intro_action_url } = guide
  const isShow = useMemo(() => {
    return intro_title && intro_desc && intro_action_url
  }, [intro_title, intro_desc, intro_action_url])
  
  return isShow ? (
    <div className='walk-in'>
      <div className='walk-in-title'>{intro_desc}</div>
      <div className='walk-in-desc' onClick={() => handleDeepLink(intro_action_url)}>
        <div>{intro_title}</div>
        <div>
          <i className='icon icon-arrow-right'></i>
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  )
}
export default WalkIn
